import { HotToastService } from '@ngneat/hot-toast';
import { RegistrationService } from 'src/app/core/services/registration.service';
import { DateTimeHelper } from 'src/app/core/services/helpers/date-time.helper';
import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { PersonalLookupInfoForTestRegistrationDto, TestSessionForRegistrationDto, UserOrderStatusDto } from 'src/app/core/dtos/dto';

import { selectRegTestSession, selectTestPurposeOption } from 'src/app/state/reg-data.selectors';
import { TestPurposeOption } from 'src/app/core/dtos/test-purpose-option';
import { BrandEnum, OrderStatusEnum } from 'src/app/core/dtos/enum';
import { Step } from 'src/app/core/dtos/step';
import { PageStepEnum, StepProgressService } from 'src/app/core/services/step-progress.service';
import { ConfigHelper } from 'src/app/core/services/helpers/config.helper';
import { selectAuthEmail } from 'src/app/state/auth.selectors';


@Component({
  selector: 'app-approved-payment',
  templateUrl: './approved-payment.component.html',
  styleUrls: ['./approved-payment.component.scss']
})

export class ApprovedPaymentComponent implements OnInit, OnDestroy {

  @Input() userOrderStatusDto: UserOrderStatusDto;
  @Input() brandId: BrandEnum;
  @Input() orderNumber: string;

  brandName: string;
  steps: Step[];
  prepareForTestUrl: string;
  userEmail$: Observable<string>;
  prepareForCELPIPUrl = "https://www.celpip.ca/prepare-for-celpip/prep-overview/";
  prepareForCAELUrl = "https://www.cael.ca/prepare-for-cael/prep-overview/";

  //Reg Info Formated
  testDate: Date;
  testTypeCssClass: string;
  testCentreCountry: string;

  testSessionInformation$: Observable<TestSessionForRegistrationDto>;
  testPurposeOption$: Observable<TestPurposeOption>;

  testSessionInformationSubscription: Subscription;
  testPurposeOptionSubscription: Subscription;
  personalLookupSubscription: Subscription;
  getTokenSubscription: Subscription;

  testSessionInformation: TestSessionForRegistrationDto;
  testPurposeOption: TestPurposeOption;
  personalLookupInfo: PersonalLookupInfoForTestRegistrationDto;
  approvedStatusNumber = OrderStatusEnum.PaymentApproved;
  pendingStatusNumber = OrderStatusEnum.Pending;
  testConfirmationEmail: string;
  localTimeZone: string;

  constructor(
    private registrationService: RegistrationService,
    private toastService: HotToastService,
    private store: Store,
    private dateTimeHelper: DateTimeHelper,
    private configHelper: ConfigHelper,
    private stepProgressServiceService: StepProgressService
  ) {
    this.steps = this.stepProgressServiceService.getSteps(PageStepEnum.Complete);
  }

  ngOnInit(): void {
    this.brandName = this.configHelper.getBrandName();
    this.prepareForTestUrl = this.brandId === BrandEnum.CELPIP ? this.prepareForCELPIPUrl : this.prepareForCAELUrl;
    this.localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    this.userEmail$ = this.store.pipe(select(selectAuthEmail));

    this.testPurposeOption$ = this.store.pipe(select(selectTestPurposeOption));
    this.testPurposeOptionSubscription = this.testPurposeOption$
      .subscribe(testPurposeOption => {
        this.testPurposeOption = testPurposeOption;
        this.renderDependentValues();
      });
    

    this.testSessionInformation$ = this.store.pipe(select(selectRegTestSession));
    this.testSessionInformationSubscription = this.testSessionInformation$
      .subscribe(sessionInfo => {
        this.testSessionInformation = sessionInfo;
        const testDateUtcToLocal = this.dateTimeHelper.convertUTCDateToLocalDate(new Date(sessionInfo.testDateTimeUtc));
        this.testDate = sessionInfo.isWebDelivery ? testDateUtcToLocal : sessionInfo.testDateTimeTestCentre;
        this.testTypeCssClass = this.configHelper.getTestTypeCssClass(this.testSessionInformation?.testTypeId);
        this.renderDependentValues();
      });

    this.personalLookupSubscription = this.registrationService.getRegPersonalLookupInfo(this.testSessionInformation.testCentreCountryId, this.testPurposeOption.testPurposeId, this.testSessionInformation.testTypeId, this.testSessionInformation.testCentreId)
      .subscribe(
        value => {
          this.personalLookupInfo = value.content;
          this.renderDependentValues();
        },
        () => this.toastService.warning("Unable to retrieve Proof of Identity Registration options.")
      );
  }

  public get BrandEnum() {
    return BrandEnum;
  }

  ngOnDestroy(): void {
    this.testSessionInformationSubscription?.unsubscribe();
    this.testPurposeOptionSubscription?.unsubscribe();
    this.personalLookupSubscription?.unsubscribe();
  }

  renderDependentValues() {
    if (this.testSessionInformation && this.personalLookupInfo) {
      //equality compare does not work between the number type id with ===
      this.testCentreCountry = this.personalLookupInfo.countries.find(x => x.id == this.testSessionInformation.testCentreCountryId)?.name;
    }
  }

  showTestConfirmationEmail() {
    const userOrderId = this.userOrderStatusDto.userOrderId;
    this.getTokenSubscription = this.registrationService.getTestRegistrationReceiptDataToken(userOrderId)
      .subscribe(
        (token) => {
          const baseUrl = this.configHelper.getBaseUrl();
          const testConfirmationEmailUrl = `${baseUrl}/#/registration/test-registration-receipt?userOrderId=${userOrderId}&token=` + encodeURIComponent(token) + `&isWebDelivery=${this.testSessionInformation.isWebDelivery}`;
          window.open(testConfirmationEmailUrl, '_blank');
        },
        () => {
          this.toastService.warning("Unable to load the page. Please contact Paragon.");
        }
      );

  }

}

